// language=GraphQL
export const ALL_TEXT_BLOCKS_QUERY = `query Query {
  textBlocks: cmsTextBlocks {
    id
    text
  }
}`

// language=GraphQL
export const SINGLE_TEXT_BLOCK_QUERY = `query Query($id: ID!) {
  textBlock: cmsTextBlock(id: $id) {
    id
    text
  }
}`

// language=GraphQL
export const CREATE_TEXT_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsTextBlockInput) {
    textBlock: createCmsTextBlock(input: $input) {
      id
      text
    }
  }`

// language=GraphQL
export const UPDATE_TEXT_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsTextBlockInput) {
    textBlock: updateCmsTextBlock(input: $input) {
      id
      text
    }
  }`

// language=GraphQL
export const DELETE_TEXT_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTextBlockInput) {
    deleteCmsTextBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TEXT_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTextBlockInput) {
    forceDeleteCmsTextBlock(input: $input) {
      success
    }
  }`
